import { PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { useTableScrollableSnapshot } from "src/components-mui/base/table-scrollable/store/table-scrollable-store";

type ITableRightMobileShadowWrapperProps = PropsWithChildren;

export const TableRightMobileShadowWrapper = ({ children }: ITableRightMobileShadowWrapperProps) => {
    const { showScrollEndShadow, shrinkFirstColumn } = useTableScrollableSnapshot();
    const showShadow = showScrollEndShadow && !shrinkFirstColumn;

    return (
        <Box
            sx={{
                position: "relative",

                " ::after": {
                    content: '""',
                    position: "absolute",
                    display: "block",
                    top: 0,
                    right: 0,
                    bottom: "-1px",
                    width: "16px",
                    zIndex: "mobileStepper",
                    pointerEvents: "none",
                    transition: "box-shadow .1s",
                    boxShadow: showShadow ? "inset -14px 1px 8px -8px white" : "inset 0 0 0 0 white",
                },
            }}
        >
            {children}
        </Box>
    );
};
